import React, { useState, useEffect } from 'react';
import img from "../../assets/images/flat.jpg";
import { FaWhatsapp, FaPhoneAlt, FaBed, FaBath } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import BottomNav from '../../component/BottomNav';
import FreeListing_property from '../../component/FreeListing_property';
import Loader from '../loader/Loader';
import WhatsAppButton from '../Whatsappbtn';
import FAQ from '../FAQ/FAQ';
import { FaUtensils } from 'react-icons/fa';
import axios from 'axios';
import { API_URL } from '../../common/constant';
import { FaSearch } from 'react-icons/fa';

const phoneNumber = '8318150076';

const Appartment_cards = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [properties, setProperties] = useState([]);


    // Filter States
    const [filters, setFilters] = useState({
        bhk: '',
        furnished: '',
        searchQuery: '',
        maxPrice: 1000000, // Maximum price filter
    });
    useEffect(() => {
        console.log("data search==>", filters.searchQuery)
        const fetchPropertieSearch = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${API_URL}/api/rentApartment/search`, {
                    params: { keyword: filters.searchQuery }
                });

                console.log("API Full Response:", response);
                console.log("API Apartments Data:", response.data);


                if (response?.data && Array?.isArray(response?.data)) {
                    setProperties(response.data);
                } else {
                    setProperties([]);
                }
            } catch (err) {
                console.error("Error fetching properties:", err);
                setError("Failed to load properties. Please try again later.");
                setProperties([]);
            } finally {
                setLoading(false);
            }
        };

        if (filters.searchQuery.length > 0) {
            fetchPropertieSearch();

        }



    }, [filters.searchQuery]);


    const handleWhatsappClick = (event) => {
        event.stopPropagation();
        window.open(`https://wa.me/${phoneNumber}`, '_blank');
    };

    useEffect(() => {
        const fetchProperties = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${API_URL}/api/rentApartment/rent-apartments`);
                // console.log("API Response:", response.data);

                if (response.data && Array.isArray(response.data.apartments)) {
                    setProperties(response.data.apartments);
                } else {
                    setProperties([]);
                }
            } catch (err) {
                console.error("Error fetching properties:", err);
                setError("Failed to load properties. Please try again later.");
                setProperties([]);
            } finally {
                setLoading(false);
            }
        };

        if (filters.searchQuery.length == 0) {
            fetchProperties();

        }
    }, []);

    // Filter Function
    const filteredProperties = properties.filter((property) => {
        const matchesBHK = filters?.bhk ? String(property.bhk)?.toLowerCase() === filters?.bhk?.toLowerCase() : true;
        const matchesFurnished = filters?.furnished ? property?.furnished.toLowerCase() === filters?.furnished?.toLowerCase() : true;
        // const matchesAddress = property?.address.toLowerCase().includes(filters.address.toLowerCase());
        const matchesPrice = property?.price <= filters?.maxPrice; // Apply max price filter

        return matchesBHK && matchesFurnished && matchesPrice;
    });

    // Handle Filter Change
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
    };
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    // Handle Slider Change
    const handleSliderChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: parseInt(value, 10), // Ensure the value is an integer
        }));
    };

    const handleNavigate = (id) => {
        navigate(`/appartment_details/${id}`);
    };

    console.log("new data response==>", properties)

    return (
        <div className="relative p-2 mx-4 flex flex-wrap gap-8">
            <div className="w-full lg:w-2/3 flex flex-col gap-8 ">
                <h1 className='py-4 text-[#54BD95] text-4xl font-bold mx-8'>Flats For Rent in Lucknow</h1>

                <div className="bg-white rounded-lg p-6 mb-8 flex flex-col lg:flex-row gap-6 items-center">

                    {/* Search Bar - Appears First on Mobile */}
                    <div className="w-full lg:w-auto">
                        <label className="block text-gray-700 font-medium mb-1">Search</label>
                        <div className="relative">
                            <input
                                type="text"
                                name="searchQuery"
                                value={filters.searchQuery}
                                onChange={handleFilterChange}
                                placeholder="Search by location, name, etc."
                                className="p-3 border border-gray-300 rounded-md w-full lg:w-96 pr-10 focus:outline-none focus:ring-2 focus:ring-[#54BD95] transition"
                            />
                            <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#54BD95]" size={20} />
                        </div>
                    </div>

                    {/* Filter Options */}
                    <div className="w-full flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                        {/* BHK & Furnishing (In a Row on Mobile) */}
                        <div className="flex flex-wrap gap-4 w-full sm:flex-nowrap lg:flex-1">
                            {/* BHK Selection */}
                            <div className="w-full sm:w-auto flex-1">
                                <label className="block text-gray-700 font-medium mb-1">BHK Type</label>
                                <select
                                    name="bhk"
                                    value={filters.bhk}
                                    onChange={handleFilterChange}
                                    className="p-3 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-[#54BD95] transition"
                                >
                                    <option value="">All BHK</option>
                                    <option value="1">1 BHK</option>
                                    <option value="2">2 BHK</option>
                                    <option value="3">3 BHK</option>
                                    <option value="4">4 BHK</option>
                                </select>
                            </div>

                            {/* Furnishing Selection */}
                            <div className="w-full sm:w-auto flex-1">
                                <label className="block text-gray-700 font-medium mb-1">Furnishing</label>
                                <select
                                    name="furnished"
                                    value={filters.furnished}
                                    onChange={handleFilterChange}
                                    className="p-3 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-[#54BD95] transition"
                                >
                                    <option value="">All Furnishing</option>
                                    <option value="Furnished">Furnished</option>
                                    <option value="Semi-furnished">Semi-furnished</option>
                                    <option value="Unfurnished">Unfurnished</option>
                                </select>
                            </div>
                        </div>

                        {/* Price Range (Below on Mobile, in Row on Desktop) */}
                        <div className="w-full lg:w-1/3">
                            <label className="block text-gray-700 font-medium mb-1">Maximum Price</label>
                            <input
                                type="range"
                                name="maxPrice"
                                min="1000"
                                max="1000000"
                                step="500"
                                value={filters.maxPrice}
                                onChange={handleSliderChange}
                                className="w-full h-2 rounded-lg appearance-none cursor-pointer focus:outline-none"
                                style={{
                                    background: `linear-gradient(to right, #54BD95 ${((filters.maxPrice - 1000) / (1000000 - 1000)) * 100}%, #ddd ${((filters.maxPrice - 1000) / (1000000 - 1000)) * 100}%)`,
                                }}
                            />
                            <span className="text-gray-700 text-sm mt-2 block">₹{filters.maxPrice}</span>
                        </div>
                    </div>
                </div>




                {loading ? (
                    <Loader />
                ) : error ? (
                    <p className="text-red-500">{error}</p>
                ) : filteredProperties.length > 0 ? (
                    filteredProperties.map((property) => (
                        <div
                            key={property._id}  // Ensure unique key
                            className="bg-white shadow-lg p-6 rounded-lg transition-all hover:shadow-xl hover:scale-105 cursor-pointer flex flex-col lg:flex-row"
                            onClick={() => handleNavigate(property._id)}
                        >
                            <div className="mb-6 lg:mb-0 lg:w-1/3">
                                <img
                                    src={img}
                                    alt="Property"
                                    className="h-60 w-full object-cover rounded-lg shadow-md transform transition-all duration-500 hover:scale-105"
                                />
                            </div>
                            <div className="lg:ml-6 text-gray-800 lg:w-2/3">
                                <h2 className="text-2xl font-semibold mb-2 hover:text-[#54BD95]">{`${property.bhk} BHK`}</h2>
                                <p className="text-sm text-gray-500 mt-2">{property.address}</p>
                                <div className="mt-4 space-y-2">
                                    <div className="flex items-center gap-2">
                                        <FaBed className="text-[#54BD95]" />
                                        <span>{property.bedrooms} Bed</span>
                                        <FaBath className="text-[#54BD95]" />
                                        <span>{property.bathrooms} Bath</span>
                                        <FaUtensils className="text-[#54BD95]" />
                                        <span>Kitchen</span>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="text-sm font-medium">Price:</p>
                                        <p className="text-lg font-bold text-[#54BD95] ml-4">₹{property.price}</p>
                                    </div>
                                    <div className="flex items-center">
                                        <p className="text-sm font-medium">Furnish Status:</p>
                                        <p className="text-lg font-bold text-[#54BD95] ml-4">{property.furnished}</p>
                                    </div>
                                    <div className="mt-2">
                                        <p className="text-sm font-medium">Facilities:</p>
                                        <div className="flex flex-wrap gap-2 mt-1">
                                            {property.facilities && property.facilities.length > 0 ? (
                                                property.facilities.map((facility, index) => (
                                                    <span key={index} className="bg-gray-200 px-3 py-1 rounded-full text-sm text-gray-700">{facility}</span>
                                                ))
                                            ) : (
                                                <span className="text-gray-500">No facilities listed</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-6 lg:mt-0 lg:ml-6 lg:flex-row lg:items-center gap-4">
                                <button
                                    onClick={handleWhatsappClick}
                                    className="flex items-center justify-center bg-[#54BD95] text-white px-6 rounded-md text-sm w-full lg:w-auto hover:bg-[#3e9e76] transition-colors duration-300 my-6 py-2"
                                >
                                    <FaWhatsapp className="text-white mr-2" size={20} />
                                    <span className="text-lg">WhatsApp</span>
                                </button>
                                <a
                                    href={`tel:${phoneNumber}`}
                                    className="flex items-center justify-center bg-[#54BD95] text-white px-6 rounded-md text-sm w-full lg:w-auto hover:bg-[#3e9e76] transition-colors duration-300 mt-6 py-2"
                                >
                                    <FaPhoneAlt className="text-white mr-3" size={20} />
                                    <span className="text-lg">Contact</span>
                                </a>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="flex flex-col items-center justify-center text-gray-500 mt-10">
                        <FaSearch className="text-6xl text-[#54BD95] mb-3" />
                        <p className="text-lg font-medium">No properties found.</p>
                    </div>

                )}
            </div>
            <FreeListing_property />
            <WhatsAppButton />
            <div className="w-full">
                <FAQ />
            </div>
            <BottomNav />
        </div>
    );
};

export default Appartment_cards;
